import objectPath from "object-path";
import React, { useMemo } from "react";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import { Topbar } from "./Topbar";

export function Header() {
  const uiService = useHtmlClassService();

  const layoutProps = useMemo(() => {
    return {
      headerClasses: uiService.getClasses("header", true),
      headerAttributes: uiService.getAttributes("header"),
      headerContainerClasses: uiService.getClasses("header_container", true),
      menuHeaderDisplay: objectPath.get(
        uiService.config,
        "header.menu.self.display"
      ),
    };
  }, [uiService]);

  return (
    <>
      {/*begin::Header*/}
      <div
        className={`header ${layoutProps.headerClasses}`}
        id="kt_header"
        {...layoutProps.headerAttributes}
      >
        {/*begin::Container*/}
        <div
          className={` ${layoutProps.headerContainerClasses} d-flex align-items-stretch justify-content-end`}
          style={{
            top: "0px",
          }}
        >
          {/* <AnimateLoading /> */}

          <Topbar />
        </div>
        {/*end::Container*/}
      </div>
      {/*end::Header*/}
    </>
  );
}
